import {Camera, MATRIX4} from '../../index.js';

/**
 * Creates Hypercube.js orthographic cameras.
 * @example
 * const cameraorthographic = new CameraOrthographic(name, options);
 */
class CameraOrthographic extends Camera {

    /**
     * Stores the bottom bound of the frustum.
     * @type {number}
     * @private
     */
    $bottom;

    /**
     * Stores the far bound of the frustum.
     * @type {number}
     * @private
     */
    $far;

    /**
     * Stores the left bound of the frustum.
     * @type {number}
     * @private
     */
    $left;

    /**
     * Stores the near bound of the frustum.
     * @type {number}
     * @private
     */
    $near;

    /**
     * Stores the right bound of the frustum.
     * @type {number}
     * @private
     */
    $right;

    /**
     * Stores the top bound of the frustum.
     * @type {number}
     * @private
     */
    $top;

    /**
     * Stores the type.
     * @type {string}
     * @protected
     */
    $type = 'camera.orthographic';

    /**
     * Gets the projection matrix of the camera.
     * @type {matrix4}
     * @public
     * @readonly
     */
    get projection() {

        return MATRIX4.orthographic(this.$left, this.$right, this.$bottom, this.$top, this.$near, this.$far);
    }

    /**
     * Creates a new Hypercube.js orthographic camera.
     * @param {string} $name The name of the orthographic camera.
     * @param {object} $options The options of the orthographic camera.
     * @param {number} $options.bottom The bottom bound of the frustum.
     * @param {number} $options.far The far bound of the frustum.
     * @param {number} $options.left The left bound of the frustum.
     * @param {number} $options.near The near bound of the frustum.
     * @param {number} $options.right The right bound of the frustum.
     * @param {number} $options.top The top bound of the frustum.
     */
    constructor($name, $options) {

        super($name);

        this.$bottom = $options.bottom;
        this.$far = $options.far;
        this.$left = $options.left;
        this.$near = $options.near;
        this.$right = $options.right;
        this.$top = $options.top;
    }
}

export {

    CameraOrthographic
};

export default CameraOrthographic;
